import type { Lang } from './langPrefs';

export const SLUG_PAIRS_BG_TO_EN: Record<string, string> = {
  продукти: 'products',
  продукт: 'product',
  количка: 'cart',
  поръчка: 'checkout',
  потвърждение: 'order-confirmation',
  любими: 'wishlist',
  проследяване: 'track',
  'за-нас': 'about',
  контакти: 'contact',
  'общи-условия': 'terms',
  поверителност: 'privacy',
  бисквитки: 'cookies',
  'политика-за-връщане': 'refund',
  грешка: 'error',
  дизайн: 'design',
  дизайнер: 'mockup-demo',
};

const SLUG_PAIRS_EN_TO_BG: Record<string, string> = Object.fromEntries(
  Object.entries(SLUG_PAIRS_BG_TO_EN).map(([bg, en]) => [en, bg])
);

function translateSlug(slug: string, fromLang: Lang, toLang: Lang): string {
  if (fromLang === toLang) return slug;
  const table = fromLang === 'bg' ? SLUG_PAIRS_BG_TO_EN : SLUG_PAIRS_EN_TO_BG;
  // React Router's location.pathname returns percent-encoded segments for
  // non-ASCII paths (e.g. /bg/продукти → "/bg/%D0%BF%D1%80..."). Decode
  // before looking up the slug pair so the table lookup hits.
  let decoded = slug;
  try {
    decoded = decodeURIComponent(slug);
  } catch {
    // malformed encoding — fall back to the raw segment
  }
  return table[decoded] ?? table[slug] ?? slug;
}

export function translatePath(
  path: string,
  fromLang: Lang,
  toLang: Lang
): string {
  const expectedPrefix = `/${fromLang}`;
  if (path !== expectedPrefix && !path.startsWith(`${expectedPrefix}/`)) {
    throw new Error(`Path "${path}" does not start with /${fromLang}`);
  }

  // Split path into [pathname, query?, hash?]
  const hashIdx = path.indexOf('#');
  const queryIdx = path.indexOf('?');
  const tailStart =
    hashIdx === -1
      ? queryIdx === -1
        ? path.length
        : queryIdx
      : queryIdx === -1
        ? hashIdx
        : Math.min(queryIdx, hashIdx);
  const pathname = path.slice(0, tailStart);
  const tail = path.slice(tailStart);

  // Strip the leading /:lang
  const rest = pathname.slice(expectedPrefix.length); // either "" or "/..."
  if (rest === '' || rest === '/') {
    return `/${toLang}${rest}${tail}`;
  }

  const segments = rest.slice(1).split('/'); // drop leading /
  segments[0] = translateSlug(segments[0], fromLang, toLang);
  return `/${toLang}/${segments.join('/')}${tail}`;
}
